/** Code venant de 360-elements pour pouvoir supprimer le package. */

/**
 * Returns an object consisting of props beyond the scope of the Component.
 *
 * @param {(Component | StatelessComponent)} Component
 * @param {Props} props
 * @returns {Props}
 */
var getProps = function getProps(Component, props) {
  var _Component$handledPro = Component.handledProps,
    handledProps = _Component$handledPro === void 0 ? [] : _Component$handledPro;
  return Object.keys(props).reduce(function (acc, prop) {
    if (prop === 'childKey') return acc;
    if (handledProps.indexOf(prop) === -1) acc[prop] = props[prop];
    return acc;
  }, {});
};
export default getProps;